import React from "react"

import { useMetricDirectory } from "../hooks/useMetricDirectory"
import { resolveMetricDescription } from "../utils/resolveMetricDescription"

interface MetricDescriptionLineProps {
  metric: {
    description?: string | null
    metric_manager?: string | null
  }
  className?: string
}

// Renders the resolved metric description (instance > catalog fallback) as a
// <p>, or nothing when both sources are empty. Hides the per-row resolution
// boilerplate at list sites.
export const MetricDescriptionLine: React.FC<MetricDescriptionLineProps> = ({
  metric,
  className,
}) => {
  const { byManager } = useMetricDirectory()
  const description = resolveMetricDescription(
    byManager[metric.metric_manager ?? ""],
    metric.description,
  )
  if (!description) {
    return null
  }
  return <p className={className}>{description}</p>
}
